import { NavigateBefore, NavigateNext } from "@mui/icons-material";
import { useRecordContext, useRedirect, useResourceContext } from "react-admin";
import { MyIconButton } from "./myIconButton";
import { Box } from "@mui/material";

export const ShowNavigation = () => {
  const resource = useResourceContext();
  const record = useRecordContext();
  const redirect = useRedirect();

  if (!record) return null;
  if (isNaN(Number(record.id))) return null;

  const prevId = record.id - 1;
  const nextId = record.id + 1;

  return (
    <Box>
      {!!prevId && (
        <MyIconButton
          onClick={() => redirect(`/${resource}/${prevId}/show`)}
          sx={{ marginRight: "5px" }}
        >
          <NavigateBefore />
        </MyIconButton>
      )}
      {nextId !== undefined && (
        <MyIconButton onClick={() => redirect(`/${resource}/${nextId}/show`)}>
          <NavigateNext />
        </MyIconButton>
      )}
    </Box>
  );
};
